export const REGGATE_TYPES = {
  STATION: 'reg-gate-for-station',
  default: 'reg-gate',
};
